import { Head, Link, useForm } from "@inertiajs/react"

import imperativeLogo from "@/assets/imperative_logo.svg"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader } from "@/components/ui/card"
import { Checkbox } from "@/components/ui/checkbox"
import { Field, FieldError, FieldGroup } from "@/components/ui/field"
import { FieldLabel } from "@/components/ui/field"
import { Input } from "@/components/ui/input"
import AuthLayout from "@/layouts/auth-layout"
import { cn } from "@/lib/utils"
import { newAdminPasswordPath } from "@/routes"

export default function AdminLogin() {
  const { data, setData, post, processing, errors } = useForm({
    admin: {
      email: "",
      password: "",
      remember_me: false as boolean,
    },
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    post("/admins/sign_in")
  }

  return (
    <AuthLayout title="" description="">
      <Head title="Admin Login" />
      <div className={cn("flex w-full flex-col gap-6")}>
        <Card>
          <CardHeader className="flex justify-center">
            <img src={imperativeLogo} alt="Imperative Logo" className="w-40" />
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit}>
              <FieldGroup>
                <Field>
                  <FieldLabel htmlFor="email">Email</FieldLabel>
                  <Input
                    id="email"
                    type="email"
                    name="admin[email]"
                    placeholder="email@example.com"
                    value={data.admin.email}
                    onChange={(e) =>
                      setData("admin", { ...data.admin, email: e.target.value })
                    }
                    required
                    autoFocus
                  />
                  {errors["admin.email"] && (
                    <FieldError>{errors["admin.email"]}</FieldError>
                  )}
                </Field>
                <Field>
                  <div className="flex items-center">
                    <FieldLabel htmlFor="password">Password</FieldLabel>
                    <Link
                      href={newAdminPasswordPath()}
                      className="ml-auto text-sm underline-offset-4 hover:underline"
                    >
                      Forgot your password?
                    </Link>
                  </div>
                  <Input
                    id="password"
                    type="password"
                    name="admin[password]"
                    value={data.admin.password}
                    onChange={(e) =>
                      setData("admin", {
                        ...data.admin,
                        password: e.target.value,
                      })
                    }
                    required
                  />
                  {errors["admin.password"] && (
                    <FieldError>{errors["admin.password"]}</FieldError>
                  )}
                </Field>
                <Field orientation="horizontal">
                  <Checkbox
                    id="remember_me"
                    name="admin[remember_me]"
                    checked={data.admin.remember_me}
                    onCheckedChange={(checked) =>
                      setData("admin", {
                        ...data.admin,
                        remember_me: checked as boolean,
                      })
                    }
                  />
                  <FieldLabel htmlFor="remember_me" className="cursor-pointer">
                    Remember me
                  </FieldLabel>
                </Field>
                <Field>
                  <Button type="submit" className="w-full" loading={processing}>
                    {processing ? "Logging in..." : "Login"}
                  </Button>
                </Field>
              </FieldGroup>
            </form>
          </CardContent>
        </Card>
      </div>
    </AuthLayout>
  )
}
